import React, { useState } from 'react';

import { useClassnames } from '@lumapps/classnames';
import {
    mdiAccountSearch,
    mdiChevronUp,
    mdiArrowCollapse,
    mdiClose,
    mdiAccountSearchOutline,
} from '@lumapps/lumx/icons';
import {
    Emphasis,
    Icon,
    Button,
    FlexBox,
    Orientation,
    Alignment,
    IconButton,
    ColorPalette,
    Size,
    Kind,
} from '@lumapps/lumx/react';
import { MessageWithActions } from '@lumapps/notifications/components/MessageWithActions';
import { useSelector } from '@lumapps/redux/react';
import { createRelativeUrl } from '@lumapps/router/utils';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { connectedUserSelector, isConnectedAs, isViewAsModeEnabled } from '@lumapps/user/ducks/selectors';
import { useUser } from '@lumapps/user/hooks/useUser';
import { USER } from '@lumapps/user/keys';
import { logoutRoute } from '@lumapps/user/routes';

import './index.scss';

const CLASSNAME = 'is-connected-as-banner';

export const IsConnectedAsBanner = () => {
    const { translate, translateKey, translateAndReplaceWithComponents } = useTranslate();
    const currentUser = useSelector(connectedUserSelector);
    const isInViewAsMode = useSelector(isConnectedAs);
    const isViewAsFFEnabled = useSelector(isViewAsModeEnabled);
    const { getUserFullName } = useUser(currentUser);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { block, element } = useClassnames(CLASSNAME);

    if (!isInViewAsMode || !isViewAsFFEnabled) {
        return null;
    }

    return (
        <div className={block({ collapsed: isCollapsed })}>
            {!isCollapsed ? (
                <MessageWithActions
                    actions={
                        <>
                            <Button
                                emphasis={Emphasis.low}
                                leftIcon={mdiArrowCollapse}
                                onClick={() => setIsCollapsed(true)}
                            >
                                {translateKey(GLOBAL.HIDE)}
                            </Button>

                            <Button
                                emphasis={Emphasis.medium}
                                href={createRelativeUrl(logoutRoute)}
                                leftIcon={mdiClose}
                                target="_self"
                            >
                                {translateKey(USER.EXIT_VIEW_MODE)}
                            </Button>
                        </>
                    }
                    icon={mdiAccountSearchOutline}
                    kind={Kind.warning}
                    message={translateAndReplaceWithComponents(USER.VIEWING_AS_USER, {
                        USER: <strong>{getUserFullName()}.</strong>,
                    })}
                />
            ) : (
                <FlexBox className={element('wrapper')} hAlign={Alignment.center} orientation={Orientation.horizontal}>
                    <IconButton
                        className={element('collapse-button')}
                        emphasis={Emphasis.low}
                        icon={mdiChevronUp}
                        label={translate(GLOBAL.EXPAND) || ''}
                        onClick={() => setIsCollapsed(false)}
                        size={Size.m}
                    />
                    <div className={element('icon-container')}>
                        <Icon icon={mdiAccountSearch} size={Size.s} color={ColorPalette.dark} />
                    </div>
                </FlexBox>
            )}
        </div>
    );
};
